import React, {useState} from 'react';
import ArrNumericInput from '../../../components/common/arr-numeric-input/ArrNumericInput';
import {Box, FormControlLabel, Switch} from '@mui/material';

const NumericInputDemo: React.FC = () => {
  const [value, setValue] = useState<number | undefined>(undefined);
  const [value2, setValue2] = useState<number | undefined>(undefined);
  const [showPercentage, setShowPercentage] = useState(true);

  return (
    <>
      <Box pt={10}>
        <FormControlLabel
        data-testid="Show Percentage Symbol"
          control={
            <Switch
              checked={showPercentage}
              onChange={(e) => setShowPercentage(e.target.checked)}
            />
          }
          label="Show Percentage Symbol"
        />

        <ArrNumericInput
          value={typeof value === 'number' ? value : undefined}
          onChange={setValue}
          minWidth="200"
          //min={0}   //now it`s optional
          //max={100} //now it`s optional
          ariaLabel="Percent Input"
          placeholder=""
          data-testid="numeric-input"
          showPercentage={showPercentage}
        />
        <Box mt={2}>
          {' '}
          Current Value: {value === undefined ? '—' : `${value}%`}
        </Box>
      </Box>
      <Box pt={8}>
        <ArrNumericInput
          value={typeof value2 === 'number' ? value2 : undefined}
          onChange={setValue2}
          minWidth="500px"
          ariaLabel="Numeric Input Demo 2"
          data-testid="numeric-input-2"
          showPercentage={false}
          sizeVariant="large"
          placeholder="100"
          label="Enter A Number"
          supportText="Enter a valid number between 0 and 255."
        />
      </Box>
    </>
  );
};

export default NumericInputDemo;
